import { Signal } from '../core/Signal';

export interface MenuOpenPayload {
  menuType: string;
  timestamp: number;
}

export interface MenuClosePayload {
  menuType: string;
  timestamp: number;
}

export interface ModalOpenPayload {
  modalId: string;
  data?: unknown;
  timestamp: number;
}

export interface ModalClosePayload {
  modalId: string;
  result?: unknown;
  timestamp: number;
}

export const createUISignals = (debugMode: boolean = false) => ({
  menuOpen: new Signal<MenuOpenPayload>('ui.menuOpen', debugMode),
  menuClose: new Signal<MenuClosePayload>('ui.menuClose', debugMode),
  modalOpen: new Signal<ModalOpenPayload>('ui.modalOpen', debugMode),
  modalClose: new Signal<ModalClosePayload>('ui.modalClose', debugMode),
});

export type UISignals = ReturnType<typeof createUISignals>;
